export default __webpack_public_path__ + "static/media/ic_pitcairn_islands.ff4ec256.svg";